import { truckImplementsApi } from "./truckImplements.api";

export const { useGetTruckImplementsQuery, useGetTruckImplementQuery, useLazyGetTruckImplementQuery, useSaveTruckImplementMutation, useSaveTruckImplementDeleteMutation } =
  truckImplementsApi;
